var $black, $green, $greenDark, $greenLight, $grey, $greyDark, $greyLight, $greyLightest, $greyMedium, $mint, $mintLight, $putty, $puttyLight, $warmgrey, $warmgreyDark, $white, allPhones, bannerHeight, body, equalizerCheck, frontpageBanners, responsiveVideo, setWidth, tablet, tabletDown;

body = $('body');

allPhones = 'only screen and (max-width : 768px)';

tablet = 'only screen and (min-width: 769px) and (max-width: 1024px)';

tabletDown = 'only screen and (max-width: 1024px)';

$black = "#000000";

$white = "#ffffff";

$greenDark = "#136e42";

$green = "#219151";

$greenLight = "#8cc6a4";

$mint = "#e3f1e3";

$mintLight = "#f1faf1";

$warmgreyDark = "#827b6b";

$warmgrey = "#d2cdc2";

$putty = "#f6f5ed";

$puttyLight = "#faf9f5";

$greyDark = "#565656";

$grey = "#7b7b7b";

$greyMedium = "#959595";

$greyLight = "#e9e8e7";

$greyLightest = "#f9f9f9";

setWidth = function () {
  if (($('.setWidth').length)) {
    return $.each($('.setWidth'), function () {
      var $this, totalWidth;
      if (($(this).children().length)) {
        $this = $(this);
        totalWidth = 2;
        $this.children().each(function () {
          totalWidth = totalWidth + $(this).outerWidth();
        });
        return $this.width(totalWidth);
      }
    });
  }
};

equalizerCheck = function () {
  if ($(document).width() >= 769 && $('body').hasClass('remove-equalize')) {
    return $('body').removeClass('remove-equalize');
  } else if ($(document).width() <= 768 && (!$('body').hasClass('remove-equalize'))) {
    return $('body').addClass('remove-equalize');
  }
};

frontpageBanners = function () {
  var $windowWidth, closeBanners, openBanners, resizeTimer, updateBanners;
  if (($('.frontpage-banner').length)) {
    openBanners = function () {
      var $newWidth;
      $newWidth = $(window).width() - 300;
      $('body').addClass('frontpage-banners-open');
      return $('.frontpage__introduction').width($newWidth);
    };
    closeBanners = function () {
      $('body').removeClass('frontpage-banners-open');
      return $('.frontpage__introduction').width('100%');
    };
    updateBanners = function () {
      if ($(document).width() >= 769) {
        return openBanners();
      } else {
        if ($('body').hasClass('frontpage-banners-open')) {
          return closeBanners();
        }
      }
    };
    $('.frontpage__banners__toggle').on('click', function (e) {
      var $newWidth;
      e.preventDefault();
      $newWidth = $(window).width() - 300;
      if ($('body').hasClass('frontpage-banners-open')) {
        return closeBanners();
      } else {
        return openBanners();
      }
    });
    resizeTimer = void 0;
    $windowWidth = $(window).width();
    $(window).on('resize', function (e) {
      var $newWindowWidth;
      $newWindowWidth = $(window).width();
      if ($windowWidth !== $newWindowWidth) {
        if ($('body').hasClass('frontpage-banners-open')) {
          $('body').removeClass('frontpage-banners-open');
          $('.frontpage__introduction').width('100%');
        }
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout((function () {
          $windowWidth = $newWindowWidth;
          return updateBanners();
        }), 250);
      }
    });
    return setTimeout((function () {
      return updateBanners();
    }), 1000);
  }
};

responsiveVideo = function () {
  var selector;
  selector = '.type-article iframe[src*="vimeo"],.type-article iframe[src*="youtube"],.type-defaultPage iframe[src*="youtube"],.type-defaultPage iframe[src*="vimeo"]';
  if (($(selector).length)) {
    return $.each($(selector), function () {
      var $thisVideo, platformClass, thisVideoHeight, thisVideoWidth, wideScreenClass, widescreenHeight;
      $thisVideo = $(this);
      thisVideoHeight = parseInt($thisVideo.attr('height'));
      thisVideoWidth = parseInt($thisVideo.attr('width'));
      widescreenHeight = Math.round(thisVideoWidth * (9 / 16));
      platformClass = '';
      wideScreenClass = '';
      if ($thisVideo[0].src.indexOf("vimeo") !== -1) {
        platformClass = ' vimeo';
      }
      $thisVideo.css({ 'height': '100%', 'width': '100%' });
      return $thisVideo.wrap('<div class="flex-video widescreen' + platformClass + '"></div>');
    });
  }
};

bannerHeight = function () {
  var imageHeight, slider;
  if ($('.liftup-link__slideshow').length && $('.liftup-link__slideshow').parents('.global-liftups-section')) {
    imageHeight = $('.liftup__image').outerHeight();
    slider = $('.global-liftups-section').find('.liftup-link__slideshow');
    slider.css('padding-bottom', imageHeight);
    $('.liftup-link__slideshow').mouseenter(function () {
      var hover;
      hover = $(this).siblings('.liftup-hover');
      return hover.addClass('hover');
    });
    return $('.liftup-link__slideshow').mouseleave(function () {
      var hover;
      hover = $(this).siblings('.liftup-hover');
      return hover.removeClass('hover');
    });
  }
};

var resizingClass = function () {
  var resizeTimer,
    $body = $('body'),
    resizingClass = 'resizing';

  $(window).on('resize', function (e) {
    if (!$body.hasClass(resizingClass)) {
      $body.addClass(resizingClass);
    }
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $body.removeClass(resizingClass);
      $(document).trigger('resized');
    }, 250);

  });
};

$(function () {
  $('[disabled], [class$="--disabled"]').on('click', function (e) {
    return e.preventDefault();
  });
  $(document).foundation({
    reveal: {
      opened: function () {
        return $('body').addClass('modal-open');
      },
      close: function () {
        return $('body').removeClass('modal-open');
      }
    },
    equalizer: {
      equalize_on_stack: true
    },
    tab: {
      callback: function (tab) {
        History.pushState({}, $(tab).find('a').data('title') + ' | Ålandsbanken', $(tab).find('a').data('url'));
        return $(document).foundation('equalizer', 'reflow');
      }
    }
  });
  equalizerCheck();
  bannerHeight();
  setWidth();
  resizingClass();
  responsiveVideo();
});

$(window).on('load', function () {
  $('body').removeClass('loading');
  setWidth();
  equalizerCheck();
  frontpageBanners();
  return bannerHeight();
});

$(window).resize(function () {
  setWidth();
  equalizerCheck();
  return bannerHeight();
});

// ---
// generated by coffee-script 1.9.2